module.exports = __webpack_public_path__ + "img/ch17_09_回收站.e93261ad.jpg";